module.exports = __webpack_public_path__ + "static/marchi-eco-73fccfe25b8ffd763d16a7f210e9f2e8.jpg";